export default {"src":"/_next/static/media/security.38babd2b.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};